module.exports = __webpack_public_path__ + "static/media/elephant.64d5400f.png";